<div>
  <div class="title">תוספות אפשריות נוספות</div>
</div>
<div *ngIf="ProductOptionItems && ProductOptionItems[0]" class="product-options">
    <div  *ngFor="let item of ProductOptionItems[0].DynamicProductOptions; let prodIndex = index">
        <div >
          <div class="dynamic-option-title"></div>
          <div class="dynamic-options-table" >
            <div class="dynamic-options-table-title">
              <div class="option-title">{{ item.OptionTitle }}</div>
              <div class="price-title">מחיר </div>
            </div>
            
            <div>
              
              <div
              *ngFor="
                let dynamicOptionItem of  item.DynamicProductOptionItems; let dynamicOptionIndex  = index
              "
              class="option-details"
              [class.active]="isDynamicOptionsChosen(dynamicOptionItem, prodIndex)"
            >
              <div class="label">{{ dynamicOptionItem.Label }}</div>
              <div class="price" *ngIf="dynamicOptionItem.Price>0">{{ dynamicOptionItem.Price }} ₪</div> 
              <div class="price" *ngIf="dynamicOptionItem.Price===0">ללא תוספת תשלום</div> 
            </div>
            </div>
            
          </div>
        </div>
      </div>
</div>

